'use strict';

export default function($stateProvider) {
  'ngInject';
  $stateProvider
    .state('business-profile-edit', {
      url: '/business/profile',
      template: '<business-profile></business-profile>',
      authenticate: true
    })
    .state('business-profile', {
      url: '/business/profile/:id',
      template: '<business-profile></business-profile>',
      authenticate: true
    })
    .state('vendor-edit', {
      url: '/business/vendor/:id',
      template: '<business-profile vendor="true"></business-profile>',
      authenticate: true
    })
    .state('vendor-show', {
      url: '/business/vendor/:id/show',
      template: '<business-profile vendor="true" show="true"></business-profile>',
      authenticate: true
    });
}



// WEBPACK FOOTER //
// ./client/app/business/profile/business-profile.routes.js